module.exports = __webpack_public_path__ + "img/logosttrsetelagoas.1ec8ba0a.png";